// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2bZuS","header":"MergedInvoice_header__2GAeX"};